module.exports = __webpack_public_path__ + "img/not-authorized.1c7aff65.svg";